export enum CardStatus {
    Focus = "focus",
    Standard = "standard",
    Inactive = "inactive",
    Completed = "completed",
    Permanent = "permanent",
    PermanentGoThrough = "permanent-go-through",
}
